
import React from 'react';
import { useSelector } from 'react-redux';
import NumberFormat from 'react-number-format';

// import './cards.css';
import iconArrowTotales from '../img/iconArrowTotales.svg';
import { Box, CircularProgress, Typography } from '@mui/material';

export const CardTotalCliente = ({ setOpenTotales }) => {

    const { total_cliente, separacion_miles, separacion_decimales, simbolo } = useSelector(state => state.ppto.detail);

    return (
        <div className='cards-totales-ppto bg-tc'>
            <CircularProgressWithLabel value={100} />
            <div className='text-center'>
                <NumberFormat
                    value={total_cliente || 0}
                    displayType={'text'}
                    thousandSeparator={separacion_miles}
                    decimalSeparator={separacion_decimales}
                    prefix={`${simbolo} `}
                    decimalScale={2}
                    fixedDecimalScale
                />
                <span style={{ fontSize: '13px' }}>Total venta neta</span>
            </div>
            <img
                style={{ cursor: 'pointer' }}
                src={iconArrowTotales}
                alt="icon"
                onClick={() => setOpenTotales(true)}
            />
        </div>
    )
}


const CircularProgressWithLabel = (props) => {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress variant="determinate" {...props} size='60px' style={{ color: '#3E80FF' }} />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography variant="caption" component="div" color="text.secondary" style={{ padding: '20px', color: '#919191' }}>
                    {`${Math.round(props.value)}%`}
                </Typography>
            </Box>
        </Box>
    );
}
